import { clampTo, hasImageInput, needsTranslation } from '../tools';
import type { SegmindModelConfig } from './types';

export const segmindModelConfigs: Record<string, SegmindModelConfig> = {
    'relight': {
        apiPath: '/v1/segmind-relighting-v2',
        pollApiPath: '',
        synchronous: true,
        enableTranslation: false,
        statusMapping: {
            taskIdPath: '',
            statePath: '',
            success: [],
            failed: [],
            processing: [],
            imageUrlPath: '',
            errorPath: 'error.message',
        },
        buildInput: (params) => {
            // 获取参数
            const { prompt, image_urls, size, aspectRatio, seed, image_size, image_resolution, providerOptions } = params;
            // 工具参数
            const po = (providerOptions ?? {}) as any;
            // 图像参数
            let image = undefined;
            if (!po.source_image_url) {
                const hasImage = hasImageInput(image_urls);
                if (!hasImage) {
                    throw new Error('Missing Image Input');
                } else {
                    image = image_urls[0];
                }
            } else {
                image = po.source_image_url;
            }
            // 图生图
            // 返回 Body 数据
            return {
                image: image,
                light_direction: typeof po?.light_direction === 'string' ? po.light_direction : 'back',
                light_type: typeof po?.light_type === 'string' ? po.light_type : 'spotlight',
                light_temperature: typeof po?.light_temperature === 'string' ? po.light_temperature : 'warm',
                light_intensity: typeof po?.light_intensity === 'string' ? po.light_intensity : 'strong',
                // system
                size: 'auto',
                quality: 'medium',
                background: 'opaque',
                output_format: 'png',
                output_compression: 100,
            };
        },
    },
};